// Color options for ribbon roses with hex codes
export const ribbonColors = [
  { name: 'Snow Pearl', hex: '#FFFFFF' },
  { name: 'Vanilla Cream', hex: '#F8F0E3' },
  { name: 'Sunbeam', hex: '#FFF9A5' },
  { name: 'Golden Glow', hex: '#D4AF37' },
  { name: 'Mocha Bliss', hex: '#6F4E37' },
  { name: 'Berry Velvet', hex: '#8B1538' },
  { name: 'Classic Ruby', hex: '#C4161C' },
  { name: 'Fuchsia Dream', hex: '#FF00FF' },
  { name: 'Rose Dust', hex: '#FFB6C1' },
  { name: 'Cotton Candy', hex: '#FFD6E8' },
  { name: 'Midnight Sapphire', hex: '#082567' },
  { name: 'Sky Breeze', hex: '#87CEEB' },
  { name: 'Ocean Mist', hex: '#9FBFBB' },
  { name: 'Emerald Charm', hex: '#046307' },
  { name: 'Midnight Noir', hex: '#0C0C0C' },
  { name: 'Violet Whisper', hex: '#9370DB' },
  { name: 'Lilac Mist', hex: '#C8A2C8' },
  { name: 'Olive Green', hex: '#6F8F3E' },
];

export const bobaBalloonColorOptions = [
  'Pink + White',
  'Red + White',
  'Pink + Black',
  'Red + Black',
];

export const mothersDayAddOns = [
  { id: 'mday-card', name: 'Add a card message', price: 1 },
];

export const valentineColors = ['Pink', 'Red', 'Pink and Red'];


// Finish options
export const finishOptions = ['Normal', 'Glitter +$10'];

// Add-on options with prices
export const addOnOptions = [
  { id: 'luxe-wrapping', name: 'Luxe Wrapping', price: 8 },
  { id: 'gold-butterfly', name: 'Gold Butterfly', price: 5 },
  { id: 'silver-butterfly', name: 'Silver Butterfly', price: 5 },
  { id: 'gold-mini-tiara', name: 'Gold Mini Tiara', price: 7 },
  { id: 'silver-mini-tiara', name: 'Silver Mini Tiara', price: 7 },
  { id: 'gold-tiara', name: 'Gold Normal Sized Tiara', price: 15 },
  { id: 'silver-tiara', name: 'Silver Normal Sized Tiara', price: 15 },
  { id: 'beaded-bow', name: 'Beaded Bow', price: 5 },
  { id: 'babys-breath', name: "Baby's Breath", price: 10 },
  { id: 'black-grad-hat', name: 'Black Graduation Hat', price: 8 },
  { id: 'yellow-grad-hat', name: 'Yellow Graduation Hat', price: 8 },
  { id: 'fairy-lights', name: 'Fairy Lights', price: 10 },
  { id: 'ferrero', name: 'Ferrero Rocher (each)', price: 3 },
  { id: 'ribbon-writing', name: 'Ribbon Writing', price: 5 },

];

export const realFlowerAddOns = [
  { id: 'orchid-stem', name: 'Orchid stem', price: 35 },
  { id: 'ribbon-details', name: 'Extra bows / ribbon details', price: 5 },
];

// Valentine's Day Add-ons
export const valentineAddOns = [
  { id: 'polaroid-photo', name: '📸 Polaroid Photo', price: 5 },
];

export const boobouquetAddOns = [
  { id: 'boobouquet-addon', name: 'Add a BooBouquet Blind Box', price: 20 },
];

export const flowerColorTones = [
  'Pastels (Pink, Lavender, Cream)',
  'Warm (Red, Orange, Yellow)',
  'Cool (Blue, Purple, White)',
  'Romantic (Pink, Red, White)',
  'Elegant (White, Cream, Green)',
  'Vibrant (Bold Mix)',
  "Creator's Choice"
];

// All Ribbon Rose Products
export const ribbonRoses = [
  {
    id: 1,
    name: '3 Rose Bouquet',
    price: '$35.00',
    soldOut: true,
    image: '/images/mini1.jpg',
    images: [
      '/images/mini1.jpg',
    ],
    category: 'ribbon',
    description: 'Three satin ribbon roses, carefully handcrafted and styled into a petite bouquet.',
    colors: ribbonColors,
    isCustomizable: true,
  },
  {
    id: 2,
    name: '7 Rose Bouquet',
    price: '$50.00',
    soldOut: true,
    image: '/images/classic1.2.jpg',
    images: [
      '/images/classic1.2.jpg',
      '/images/classic1.jpg',
    ],
    category: 'ribbon',
    description: 'Seven satin ribbon roses, delicately handcrafted and arranged to create a fuller, more expressive bouquet.',
    colors: ribbonColors,
    isCustomizable: true,
  },
  {
    id: 3,
    name: '12 Rose Bouquet',
    price: '$85.00',
    soldOut: true,
    image: '/images/sig1.jpg',
    images: [
      '/images/sig1.jpg',
    ],
    category: 'ribbon',
    description: 'Twelve handcrafted satin ribbon roses, elegantly arranged into a full and romantic bouquet.',
    colors: ribbonColors,
    isCustomizable: true,
  },
  {
    id: 4,
    name: '18 Rose Bouquet',
    price: '$120.00',
    soldOut: true,
    image: '/images/grande1.jpg',
    images: [
      '/images/grande1.jpg',
      '/images/grande1.2.jpg',
    ],
    category: 'ribbon',
    description: 'A generous arrangement of eighteen handcrafted satin ribbon roses, styled to create a rich and elegant bouquet.',
    colors: ribbonColors,
    isCustomizable: true,
  },
  {
    id: 5,
    name: '24 Rose Bouquet',
    price: '$160.00',
    soldOut: true,
    image: '/images/lux1.jpg',
    images: [
      '/images/lux1.jpg',
    ],
    category: 'ribbon',
    description: 'A grand arrangement of twenty-four handcrafted satin ribbon roses, styled to create a beautifully abundant and elegant bouquet.',
    colors: ribbonColors,
    isCustomizable: true,
  },
  {
    id: 6,
    name: '36 Rose Bouquet',
    price: '$220.00',
    soldOut: true,
    image: '/images/royal1.jpg',
    images: [
      '/images/royal1.jpg',
      '/images/thumbnail.jpg',
    ],
    category: 'ribbon',
    description: 'An extravagant arrangement of thirty-six handcrafted satin ribbon roses, styled for maximum fullness and elegance.',
    colors: ribbonColors,
    isCustomizable: true,
  },
  {
    id: 7,
    name: '50 Rose Bouquet',
    price: '$280.00',
    soldOut: true,
    image: '/images/grand1.jpg',
    images: [
      '/images/grand1.jpg',
    ],
    category: 'ribbon',
    description: 'Fifty handcrafted satin ribbon roses, meticulously arranged into an ultra-luxurious and breathtaking bouquet.',
    colors: ribbonColors,
    isCustomizable: true,
  },
];

// All Real Flower Products
export const realFlowers = [
  {
    id: 8,
    name: 'Small Bouquet',
    price: 100.00,
    soldOut: true,
    image: '/images/smallBouquet.jpg',
    images: [
      '/images/real3.jpg',
    ],
    category: 'real',
    description: '3-4 seasonal flower varieties',
    fulldescription: 'Each bouquet is thoughtfully arranged using seasonal blooms. Photos are provided as a size and style guide only. Exact flower varieties may vary depending on availability, while the overall size and value will be maintained.',
    colorPreferences: {
      heading: 'Colour preferences:',
      text: "Select 1 colour tone",
      maxSelections: 1
    },
    addOns: realFlowerAddOns,

    giftMessage: {
      required: true,
      text: 'Please include a short message to be written on the card for your recipient. (pls make this required)'
    },
  },
  {
    id: 9,
    name: 'Classic Bouquet',
    price: 150.00,
    soldOut: true,
    image: '/images/realClass1.jpg',
    images: [
      '/images/realClass1.jpg',
    ],
    category: 'real',
    description: '5-6 seasonal flower varieties',
    fulldescription: 'A fuller arrangemnet featuring a wider mix of seasonal blooms. Photos are provided as a size and style guide only. Exact flower varieties may vary depending on availability, while the overall size, fullness and value will be maintained.',
    colorPreferences: {
      heading: 'Colour preferences:',
      text: "Select 1 colour tone",
      maxSelections: 1
    },
    addOns: realFlowerAddOns,
    
    giftMessage: {
      required: true,
      text: 'Please include a short message to be written on the card for your recipient.'
    },
    colors: [],
  },
  {
    id: 10,
    name: 'Large Bouquet',
    price: 210.00,
    soldOut: true,
    image: '/images/realLarge.jpg',
    images: [
      '/images/realLarge.jpg',
    ],
    category: 'real',
    description: '7-8 seasonal flower varieties',
    fulldescription: 'A generous, statement arrangemnet featuring a braoder selection of seasonal blooms with added height and fullness. Photos are provided as a size and style guide only. Exact flower varieties may vary depending on availability, while the overall size, fullness and value will be maintained.',
    colorPreferences: {
      heading: 'Colour preferences:',
      text: "Select 1 colour tone",
      maxSelections: 1
    },
    addOns: realFlowerAddOns,
    giftMessage: {
      required: true,
      text: 'Please include a short message to be written on the card for your recipient.'
    },
  },
  {
    id: 11,
    name: 'Small Basket',
    price: 95.00,
    soldOut: true,
    image: '/images/realSmall.jpg',
    images: [
      '/images/realSmall.jpg',
    ],
    category: 'real',
    description: 'A petite arrangement featuring 3-4 seasonal flower varieties, perfect for a thoughtful gesture or minimal floral moment',
    fulldescription: 'Each bouquet is thoughtfully arranged using seasonal blooms. Photos are provided as a size and style reference only. Exact flower varieties may very depending on availability, while overall size and value will be maintained.',
    colorPreferences: {
      heading: 'Colour preferences:',
      text: "Select 1 colour tone",
      maxSelections: 1
    },
    addOns: realFlowerAddOns,
    
    giftMessage: {
      required: true,
      text: 'Please include a short message to be written on the card for your recipient.'
    },
  },
  {
    id: 12,
    name: 'Large Basket',
    price: 150.00,
    soldOut: true,
    image: '/images/largeBasket.jpg',
    images: [
      '/images/largeBasket.jpg',
    ],
    category: 'real',
    description: 'A fuller statement floral basket featuring 5-7 seasonal flower varieties, designed to feel abundant and eye catching while remaining soft and elegant.',
    fulldescription: 'Each arrangement is carefully curated using seasonal blooms. Photos are provided as a size and style guide only. Flower varieties may vary depending on availability, while the overall size, fullness and value will be maintained.',
    colorPreferences: {
      heading: 'Colour preferences:',
      text: "Select 1 colour tone",
      maxSelections: 1
    },
    addOns: realFlowerAddOns,
    giftMessage: {
      required: true,
      text: 'Please include a short message to be written on the card for your recipient.'
    },
  },
  {
    id: 13,
    name: 'Custom Bouquet',
    price: 'From $100.00',
    soldOut: true,
    image: '/images/real1.jpg',
    images: [
      '/images/real1.jpg',
      '/images/real2.jpg',
    ],
    category: 'real',
    description: 'A fully custom fresh flower bouquet, designed to your colour preferences and style. Each arrangement is thoughtfully crafted using seasonal blooms, allowing our florist to create something unique just for you.',
    colors: [],
    isCustomOrder: true,
  },
];

export const corsages = [
  {
    id: 14,
    name: 'Corsage and Boutonniere',
    price: 'From $25.00',
    image: '/images/cor1.jpg',
    images: [
      '/images/cor1.jpg',
    ],
    category: 'corsage',
    description: 'Elegant wrist corsage perfect for formals, weddings, and special occasions.',
    colors: ribbonColors,
    isCustomizable: true,
    isBooBouquet: true,
  },
];

// BooBouquet
export const boobouquet = [
  {
    id: 26,
    name: "BOOBOUQUET: SCULTPTED LOVE COLLECTION",
    price: 20.00,
    image: '/images/b1.jpg',
    images: [
      '/images/b1.jpg',
      '/images/b2.jpg',
      '/images/b3.jpg',
      '/images/b4.jpg',
      '/images/b5.jpg',
      '/images/b6.jpg',
      '/images/b7.jpg',
      ],
    category: 'boobouquet',
    description: 'A surprise mini flower bouquet keychain. Collect them all!',
    fulldescription: 'A tiny treasure with a big surprise! Our Valentines Day BooBouquet Blind Box features a handcrafted mini flower bouquet keychain, delicately wrapped and finished with an elegant bow and heart charm.',
    isValentine: true,
  },
];

// Valentine's Day Special Bouquets
export const valentinesBouquets = [
  {
    id: 17,
    name: "Reflexed Rose Bouquet",
    price: 130.00,
    image: '/images/reflexed.jpg',
    images: [
      '/images/reflexed.jpg',
    ],
    category: 'valentine',
    description: 'Pink roses with baby\'s breath',
    colors: valentineColors,
    fulldescription: 'Each Valentine\'s Day fresh flower bouquet includes a complimentary keepsake photo of the bouquet.',
    addOns: valentineAddOns,
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
    soldOut: true,
    isRamoStyle: true, // ✅ Reuse the same dropdown logic
    ramoOptions: [
      { count: 10, price: 130 },
      { count: 15, price: 185 },
      { count: 24, price: 285 },
      { count: 40, price: 440 },
      { count: 50, price: 600 }
    ],
  },
  {
    id: 20,
    name: "Closed Rose Bouquet",
    price: '$120.00',
    image: '/images/closed.jpg',
    images: [
      '/images/closed.jpg',
    ],
    category: 'valentine',
    description: 'Mixed roses in pastel colors',
    colors: valentineColors,
    fulldescription: 'Each Valentine\'s Day fresh flower bouquet includes a complimentary keepsake photo of the bouquet.',
    addOns: valentineAddOns,
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
    soldOut: true,
    isRamoStyle: true,
    ramoOptions: [ // ADD THIS
    { count: 10, price: 120 },
    { count: 15, price: 170 },
    { count: 24, price: 265 },
    { count: 40, price: 420 },
    { count: 50, price: 550 },
    { count: 100, price: 1150 },
  ],
  },
  {
    id: 21,
    name: "Ribbon Roses",
    price: 60.00,
    image: '/images/grande1.jpg',
    images: [
      '/images/grande1.jpg',
      '/images/thumbnail.jpg',
    ],
    category: 'valentine',
    colors: valentineColors,
    fulldescription: 'A charming mix of pastel-colored roses arranged to perfection. Sweet, romantic, and perfect for Valentine\'s Day.',
    addOns: valentineAddOns,
    isCustomizable: true,
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
    soldOut: true,
    isRamoStyle: true,
    ramoOptions: [ // ADD THIS
    { count: 7, price: 60 },
    { count : 12, price: 100 },
    { count: 18, price: 140 },
    { count: 36, price: 260 },
    { count: 50, price: 330 }
  ],
  },
  {
    id: 27,
    name: "Small Choc Bouquet",
    price: 155.00,
    image: '/images/chocSmall.jpg',
    images: [
      '/images/chocSmall.jpg',
    ],
    category: 'valentine',
    colors: ['Pink', 'Red'],
    chocolateOptions: ['Ferrero Rocher', 'Rafaello'],
    fulldescription: 'A charming mix of pastel-colored roses arranged to perfection. Sweet, romantic, and perfect for Valentine\'s Day.',
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
    soldOut: true,
    hasChocolateChoice: true
  },
  {
    id: 28,
    name: "Large Choc Bouquet",
    price: 360.00,
    image: '/images/chocLarge.jpg',
    images: [
      '/images/chocLarge.jpg',
    ],
    category: 'valentine',
    colors: ['Pink', 'Red'],
    chocolateOptions: ['Ferrero Rocher', 'Rafaello'],
    fulldescription: 'A charming mix of pastel-colored roses arranged to perfection. Sweet, romantic, and perfect for Valentine\'s Day.',
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
    soldOut: true,
    hasChocolateChoice: true
  },
  {
    id: 29,
    name: "Ask Her Out Bouquet",
    price: '$35.00',
    image: '/images/ao.jpg',
    images: [
      '/images/ao.jpg',
    ],
    category: 'valentine',
    description: 'Available for pickup before 10th February',
    fulldescription: 'A romantic bouquet featuring ribbon roses with a vintage-style newspaper promposal card',
    addOns: boobouquetAddOns,
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
    soldOut: true,
    lastDeliveryDate: '2026-02-10', // ✅ Add this
  },

  {
    id: 22,
    name: "Boba Balloon With Flowers",
    price: '$195.00',
    image: '/images/Boba.jpg',
    images: [
      '/images/Boba.jpg',
    ],
    category: 'valentine',
    description: 'Romantic boba balloon with fresh flowers',
    fulldescription: 'Fresh pastel roses and baby’s breath arranged beneath a clear boba balloon with Valentine balloon accents.',
    addOns: valentineAddOns,
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
  },
  {
    id: 23,
    name: "Boba Balloon With Polaroid Holder",
    price: '$85.00',
    image: '/images/bobaPolaroid.jpg',
    images: [
      '/images/bobaPolaroid.jpg',
      '/images/bobaO1.jpg',
      '/images/boba02.jpg',

    ],
    category: 'valentine',
    description: 'Romantic boba balloon with polaroid photo holder',
    fulldescription: 'Sweet, romantic, and designed to be cherished long after Valentine’s Day. We will be in contact with you to get the photo.',
    bobaColors: bobaBalloonColorOptions,
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
  },
  {
    id: 24,
    name: "Strawberry Bear",
    price: 95.00,
    image: '/images/strawb.jpg',
    images: [
      '/images/strawb.jpg',
    ],
    category: 'valentine',
    description: 'Approx 35 cm',
    fulldescription: 'This item is available for pre-order. Stock is expected to arrive in early February. While we anticipate arrival before Valentines Day, we cannot guarantee delivery by February 14th. If this item does not arrive in time for Valentine’s Day, a full refund will be issued. By placing an order, you acknowledge and accept this condition.',
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
  },
  {
    id: 25,
    name: "Rose Bear",
    price: 35.00,
    image: '/images/redRB.jpg',
    images: [
      '/images/redRB.jpg',
      '/images/pinkRB.jpg'
    ],
    category: 'valentine',
    colors: valentineColors,
    description: 'Approx 25 cm + Gift Box',
    fulldescription: 'This item is available for pre-order. Stock is expected to arrive in early February. While we anticipate arrival before Valentines Day, we cannot guarantee delivery by February 14th. If this item does not arrive in time for Valentine’s Day, a full refund will be issued. By placing an order, you acknowledge and accept this condition.',
    giftMessage: {
      required: true,
      text: 'Please include a short message for your Valentine.'
    },
    isValentine: true,
  },
  {
    id: 26,
    name: "BOOBOUQUET: SCULTPTED LOVE COLLECTION",
    price: 20.00,
    image: '/images/b1.jpg',
    images: [
      '/images/b1.jpg',
      '/images/b2.jpg',
      '/images/b3.jpg',
      '/images/b4.jpg',
      '/images/b5.jpg',
      '/images/b6.jpg',
      '/images/b7.jpg',
      ],
    category: 'valentine',
    description: 'A surprise mini flower bouquet keychain. Collect them all!',
    fulldescription: 'A tiny treasure with a big surprise! Our Valentines Day BooBouquet Blind Box features a handcrafted mini flower bouquet keychain, delicately wrapped and finished with an elegant bow and heart charm.',
    isValentine: true,
  },

];

export const mothersDayProducts = [
  {
    id: 32,
    name: 'Sunflower Bouquet',
    price: 45.00,
    image: '/images/sunflowerb.jpg',
    images: ['/images/sunflowerb.jpg'],
    category: 'mothersday',
    addOns: mothersDayAddOns,
    description: 'A bright and cheerful handcrafted bouquet featuring vibrant sunflowers and delicate blooms, beautifully wrapped and ready to gift. Made with fuzzy wire flowers, this bouquet lasts forever and becomes a sweet keepsake Mum can treasure.',
  },
  {
    id: 33,
    name: 'Lily Bouquet',
    price: 45.00,
    image: '/images/lilyb2.0.jpeg',
    images: ['/images/lilyb.jpg'],
    category: 'mothersday',
    addOns: mothersDayAddOns,
    description: 'A soft and romantic bouquet designed with vibrant pink lilies and dainty details for a delicate, feminine look. Thoughtfully handcrafted and beautifully wrapped, it’s a lasting gift Mum can keep and admire well beyond Mother’s Day.'
  },

  {
    id: 34,
    name: 'Sunflower Chocolate Box',
    price: 55.00,
    image: '/images/sunflowerCHOC.jpg',
    images: ['/images/sunflowerCHOC.jpg'],
    category: 'mothersday',
    addOns: mothersDayAddOns,
    description: 'A playful and thoughtful arrangement featuring bright sunflowers paired with sweet chocolates for the perfect mix of cute and indulgent. Handcrafted and beautifully presented, it’s a unique gift that’s sure to make Mum smile.'
  },

  {
    id: 35,
    name: 'Pink Chocolate Box',
    price: 55.00,
    image: '/images/pinkchoc.jpg',
    images: ['/images/pinkchoc.jpg'],
    category: 'mothersday',
    addOns: mothersDayAddOns,
    description: 'A fun and vibrant arrangement featuring soft pastel flowers with a pop of colour, paired with sweet chocolates for an extra treat. Carefully handcrafted and beautifully presented, it’s the perfect little surprise to brighten Mum’s day.'
  },

  {
    id: 36,
    name: 'Mothers Day Bear Box',
    price: 65.00,
    image: '/images/mdaybb.jpg',
    images: ['/images/mdaybb.jpg'],
    category: 'mothersday',
    addOns: mothersDayAddOns,
    description: 'A sweet and heartfelt gift featuring a soft teddy bear surrounded by delicate blooms, all beautifully presented in a keepsake box. Thoughtfully designed to feel extra special, it’s the perfect way to surprise Mum with something she’ll adore.'
  },

  {
  id: 37,
  name: 'Choc Box Bundle',
  price: 100.00,
  image: '/images/chocBundle.jpeg',
  images: ['/images/chocBundle.jpeg', '/images/pinkchoc.jpg', '/images/sunflowerCHOC.jpg'],
  category: 'mothersday',
  addOns: mothersDayAddOns,
  description: 'Get any 2 choc boxes for $100 - mix and match Sunflower and Pink.',
  isBundle: true,
  bundleOptions: [
    { label: '2x Sunflower Choc Box', price: 100 },
    { label: '2x Pink Choc Box', price: 100 },
    { label: '1x Sunflower + 1x Pink Choc Box', price: 100 },
  ],
},
{
  id: 38,
  name: 'Bouquet Bundle',
  price: 80.00,
  image: '/images/bbundle.jpeg',
  images: ['/images/bbundle.jpeg', '/images/lilyb.jpg', '/images/sunflowerb.jpg'],
  category: 'mothersday',
  addOns: mothersDayAddOns,
  description: 'Get any 2 bouquets for $80 — mix and match Sunflower and Lily.',
  isBundle: true,
  bundleOptions: [
    { label: '2x Sunflower Bouquet', price: 80 },
    { label: '2x Lily Bouquet', price: 80 },
    { label: '1x Sunflower + 1x Lily Bouquet', price: 80 },
  ],
},

{
  id: 39,
  name: 'Double Bear Box Bundle',
  price: 120.00,
  image: '/images/bearbundle.jpeg',
  images: ['/images/bearbundle.jpeg','/images/mdaybb.jpg'],
  category: 'mothersday',
  addOns: mothersDayAddOns,
  description: 'Get 2 Mothers Day Bear Boxes for $120 — save $10.',
  isBundle: true,
  bundleOptions: [
    { label: '2x Mothers Day Bear Box', price: 120 },
  ],
},

];

// Combined array of all products
export const allProducts = [...ribbonRoses, ...realFlowers, ...corsages, ...boobouquet, ...valentinesBouquets, ...mothersDayProducts];

// Helper function to get product by ID
export const getProductById = (id) => {
  return allProducts.find(product => product.id === parseInt(id));
};